<div
  class="card card-shadow"
  [class.bg-grey]="isSubmitDisabled && payrollStartData?.ActivePayroll?.PayType != 0">
  <div class="card-body d-flex flex-column">
    <h3 class="card-title">{{ activeAutoPayGrid ? 'Auto-Payroll Skipped' : 'Run Payroll' }}</h3>
    <ng-container
      *ngIf="payrollStartConfig.Unsupported?.length; then no_functionality; else payroll">
    </ng-container>
    <ng-template #no_functionality>
      We are not quite ready for payrolls with
      {{ payrollStartConfig.Unsupported[0] }}. We will let you know when new functionality is
      available. For now, please enter this client's payroll in the APS system.
    </ng-template>
    <ng-template #payroll>
      <div *ngIf="activeAutoPayGrid">
        Auto-payroll has been skipped for <strong>{{ dateUntilNextPayrollSubmission }}</strong>
      </div>
      <div *ngIf="!activeAutoPayGrid">
        <h5
          *ngIf="
            (!isPrefundLocked || payrollStartData?.ActivePayroll?.PayType != 0) &&
            !isPayDateInvalid &&
            daysUntilNextPayrollSubmission > 0
          ">
          There {{ pluralize('is', daysUntilNextPayrollSubmission, 'are', true) }}
          <span class="fw-bold"
            >{{ daysUntilNextPayrollSubmission }}
            {{ pluralize('day', daysUntilNextPayrollSubmission, 's') }}</span
          >
          left to submit payroll.
        </h5>
        <h5
          *ngIf="
            (!isPrefundLocked || payrollStartData?.ActivePayroll?.PayType != 0) &&
            !isPayDateInvalid &&
            daysUntilNextPayrollSubmission < 1
          ">
          Payroll Due Today
        </h5>
      </div>
      <div *ngIf="payrollStartData?.ActivePayroll && payrollStartData?.ActivePayroll?.PayType == 0">
        <h6 class="cp-green fw-bold mb-0">Entry in progress</h6>
        <small class="cp-green">
          Last edit by {{ payrollStartData.ActivePayroll.LastEditBy }} on
          {{ payrollStartData.ActivePayroll.LastEditOn | date: 'MM/dd/yyyy h:mma' }}
        </small>
      </div>
      <div *ngIf="isClientPortal && payrollStartData.ActivePayroll?.PayType == payTypes.Adjustment">
        <h5 class="cp-green fw-bold mb-0">Payroll entry in progress</h5>
        <small class="cp-green">
          Last edit by {{ payrollStartData.ActivePayroll.LastEditBy }} on
          {{ payrollStartData.ActivePayroll.LastEditOn | date: 'MM/dd/yyyy h:mma' }}
        </small>
      </div>
      <div
        *ngIf="
          payrollStartData?.ActivePayroll &&
          payrollStartData?.ActivePayroll?.PayType == 0 &&
          isPayDateInvalid
        ">
        <h5>
          This payroll is overdue and cannot be resumed. Cancel the payroll to proceed. If you have
          any questions, contact your Payroll Specialist.
        </h5>
      </div>
    </ng-template>
    <div class="row mt-auto">
      <div class="col-auto mt-3" *ngIf="!isPayDateInvalid && !activeAutoPayGrid">
        Submit by<br />
        {{ dateUntilNextPayrollSubmission }}
      </div>
      <div class="col d-flex justify-content-end align-items-center">
        <button
          *ngIf="
            payrollStartData?.ActivePayroll &&
            payrollStartData?.ActivePayroll?.PayType == 0 &&
            isPayDateInvalid
          "
          type="button"
          (click)="cancelPayroll()"
          class="btn btn-danger float-end mt-4 mr-4 align-self-end">
          Cancel Payroll
        </button>
        <button
          *ngIf="!isPayDateInvalid"
          type="button"
          cpGTagEvent
          [params]="{
            event_label: payrollStartData?.ActivePayroll
              ? 'run_payroll_tile_resume'
              : 'run_payroll_tile_start'
          }"
          [disabled]="isSubmitDisabled"
          class="btn btn-primary float-end mt-4"
          (click)="navigatePayroll()"
          data-testid="run-payroll-tile-btn">
          {{
            payrollStartData?.ActivePayroll && payrollStartData.ActivePayroll.PayType == 0
              ? 'Resume Payroll'
              : 'Start Payroll'
          }}
        </button>
      </div>
    </div>
  </div>
</div>
